export default "__VITE_ASSET__DnHsecpp__"